export let personaCheckboxSelectMessageLabel = "uwIyjb";
export let personaCheckboxSelectConversationLabel = "a5ZBvc";
export default {personaCheckboxSelectMessageLabel,personaCheckboxSelectConversationLabel};